import React, { useState, useEffect } from 'react'
import { auth } from '../firebase';

function Menu() {
    const [user, setUser] = useState();

    useEffect(() => {
        const unsub = auth.onAuthStateChanged((user) => {
            setUser(user);
        });
        return () => unsub();
    }, []);

    return (
        <div>
            {/* Main Sidebar Container */}
           <aside className="main-sidebar sidebar-dark-danger elevation-4" 
                   style={{ backgroundColor: '#0f172a', position: 'fixed', height: '100vh', overflow: 'hidden' }}>
                
                {/* FIXED HEADER: Brand Link */}
                <a href="/home" className="brand-link" style={{ borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'block' }}>
                    <div className="brand-image img-circle elevation-3 d-flex align-items-center justify-content-center" 
                         style={{ opacity: '.8', background: '#D90000', width: '33px', height: '33px' }}>
                        <i className="fa fa-user text-white" style={{ fontSize: '14px' }}></i>
                    </div>
                    <span className="brand-text font-weight-light" style={{ letterSpacing: '1px', fontWeight: 'bold' }}>Admin</span>
                </a>
                <div className="sidebar">
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                            
                            {/* DASHBOARD */}
                            <li className="nav-item">
                                <a href="/home" className="nav-link">
                                    <i className="nav-icon fas fa-tachometer-alt" />
                                    <p> Dashboard</p>
                                </a>
                            </li>

                            {/* DAILY SALES SECTION */}
                            <li className="nav-header">DAILY OPERATIONS</li>
                            <li className="nav-item">
                                <a href="/nozzle-readings" className="nav-link">
                                    <i className="nav-icon fas fa-faucet" />
                                    <p> Nozzle Readings (मि.)</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/daily-dip-entry" className="nav-link">
                                    <i className="nav-icon fas fa-fill-drip" />
                                    <p>Tank Dip Entry</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/daily-denomination" className="nav-link">
                                    <i className="nav-icon fas fa-coins" />
                                    <p>Daily Denomination</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/purchase-stock" className="nav-link">
                                    <i className="nav-icon fas fa-table" />
                                    <p>Purchase Stock</p>
                                </a>
                            </li>

                             {/* CREDIT MANAGEMENT (UDARI) */}
                            <li className="nav-header">CREDIT CUSTOMERS (उधारी)</li>
                            <li className="nav-item">
                                <a href="/credit-customers" className="nav-link">
                                    <i className="nav-icon fas fa-user-tag" />
                                    <p>Customer List</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/customer-ledger" className="nav-link">
                                    <i className="nav-icon fas fa-file-invoice-dollar" />
                                    <p>Customer Ledger</p>
                                </a>
                            </li>

                            {/* INVENTORY & PURCHASES */}
                            <li className="nav-header">INVENTORY (STOCK)</li>
                            <li className="nav-item">
                                <a href="/sale-entry" className="nav-link">
                                    <i className="nav-icon fas fa-book" />
                                    <p> Sale (Outward)</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/purchase-entry" className="nav-link">
                                    <i className="nav-icon fas fa-truck-moving" />
                                    <p> Purchase (Inward)</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/vendors-mgmt" className="nav-link">
                                    <i className="nav-icon fas fa-user" />
                                    <p>Vendor Mgmt</p>
                                </a>
                            </li>
                             <li className="nav-item">
                                <a href="/vendors-account" className="nav-link">
                                    <i className="nav-icon fas fa-money" />
                                    <p>Vendor Account</p>
                                </a>
                            </li>
                             <li className="nav-item">
                                <a href="/lubricants-inventory" className="nav-link">
                                    <i className="nav-icon fas fa-oil-can" />
                                    <p>Lubricants / Oil Stock</p>
                                </a>
                            </li>

                            {/* ACCOUNTS & EXPENSES */}
                            <li className="nav-header">Daily Expense</li>
                            <li className="nav-item">
                                <a href="/pump-expenses" className="nav-link">
                                    <i className="nav-icon fas fa-wallet" />
                                    <p>Daily Expenses (खर्च)</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/expense-heads" className="nav-link">
                                    <i className="nav-icon fas fa-wallet" />
                                    <p>Expense Head</p>
                                </a>
                            </li>
                             <li className="nav-item">
                                <a href="/staff-mgmt" className="nav-link">
                                    <i className="nav-icon fas fa-wallet" />
                                    <p>Staff Mgmt</p>
                                </a>
                            </li>
                             {/* <li className="nav-item">
                                <a href="/advance-payments" className="nav-link">
                                    <i className="nav-icon fas fa-wallet" />
                                    <p>Advance Payments</p>
                                </a>
                            </li>
                             <li className="nav-item">
                                <a href="/monthly-payment" className="nav-link">
                                    <i className="nav-icon fas fa-wallet" />
                                    <p>Monthly Payments</p>
                                </a>
                            </li> */}

                            {/* REPORTS */}
                            <li className="nav-header">REPORTS & ANALYSIS</li>
                            <li className="nav-item">
                                <a href="/dsr-report" className="nav-link">
                                    <i className="nav-icon fas fa-chart-line" />
                                    <p>Daily Settlement (DSR)</p>
                                </a>
                            </li>
                            {/* <li className="nav-item">
                                <a href="/variation-report" className="nav-link">
                                    <i className="nav-icon fas fa-exclamation-triangle" />
                                    <p>Stock Variation (फरक)</p>
                                </a>
                            </li> */}
                            <li className="nav-item">
                                <a href="/sale-purchase-report" className="nav-link">
                                    <i className="nav-icon fas fa-history" />
                                    <p>Sales/Purchase History</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/headwise-report" className="nav-link">
                                    <i className="nav-icon fas fa-history" />
                                    <p>Expense Headwise Report</p>
                                </a>
                            </li>

                            {/* MASTERS */}
                            <li className="nav-header">CONFIGURATION</li>
                            <li className="nav-item">
                                <a href="/nozzle-master" className="nav-link">
                                    <i className="nav-icon fas fa-tools" />
                                    <p>Pump Nozzle Master</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/tank-master" className="nav-link">
                                    <i className="nav-icon fas fa-database" />
                                    <p>Tank Configuration</p>
                                </a>
                            </li>
                            {/* <li className="nav-item">
                                <a href="/staff-mgmt" className="nav-link">
                                    <i className="nav-icon fas fa-users-cog" />
                                    <p>Staff/Employee Mgmt</p>
                                </a>
                            </li> */}
                            <li className="nav-item">
                                <a href="/pump-details" className="nav-link">
                                    <i className="nav-icon fas fa-address-card" />
                                    <p>Pump Details</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/payment-modes" className="nav-link">
                                    <i className="nav-icon fas fa-money" />
                                    <p>Payment Modes</p>
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <br/><br/><br/>
                </div>
            </aside>
            {/* Custom Scrollbar Styling */}
            <style dangerouslySetInnerHTML={{ __html: `
                .sidebar::-webkit-scrollbar {
                    width: 5px;
                }
                .sidebar::-webkit-scrollbar-track {
                    background: transparent;
                }
                .sidebar::-webkit-scrollbar-thumb {
                    background: rgba(255,255,255,0.1);
                    border-radius: 10px;
                }
                .sidebar::-webkit-scrollbar-thumb:hover {
                    background: rgba(255,255,255,0.2);
                }
                .nav-header{font-size:10px !important;color:"#7b7979 !important"}
            `}} />
        </div>
    )
}

export default Menu;